import { isWindows } from '@local/common-web';

export const join = (prefix: string, suffix: string) => `${prefix}${pathSeperator}${suffix}`;
export const pathSeperator: string = isWindows() ? '\\' : '/';
